export function isBreakpoint(value) {
    return ['xs', 'sm', 'md', 'lg', 'xl'].includes(value);
}
//# sourceMappingURL=breakpoint.js.map